import React from 'react'

const LinkStyle = (props) => {
    if (props.primary_colour) {
        return (
            <style>
            {`
                .prose-${props._uid} a {
                    color: ${props.primary_colour};
                } 
            
                .prose-${props._uid} a:hover {
                    filter: brightness(0.8);
                }
            `}
            </style>
        )
    } else return ''
}

export default LinkStyle